import { makeStyles, darken } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 66,
      justifyContent: 'start',
      backgroundColor: COLORS.neutral.darkGray,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1.5),
      border: 'unset',

      '&:hover': {
        backgroundColor: darken(COLORS.neutral.darkGray, 0.2),
      },
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      columnGap: theme.spacing(1.5),
    },
    row: {},
    img: {},
    title: {
      display: 'block',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightSemiBold,
      fontFamily: theme.typography.fontRobotoSlab,
      color: COLORS.neutral.lightGray,
      whiteSpace: 'nowrap',

      '& span': {
        fontSize: theme.typography.pxToRem(12),
        color: COLORS.neutral.mediumLightGray,
        fontWeight: theme.typography.fontWeightRegular,
        fontFamily: theme.typography.fontFamily,
      },
    },
    description: {
      display: 'block',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.lightGray,
    },
  }),
  { name: 'ButtonExtension' }
);
